// extracted by mini-css-extract-plugin
export default {"wrapper":"Xjro2E3tb7a66q8BxNTf","editValueBtn":"J6kAQmaiKV5kZw1l43in","editValueBtnIcon":"KGOXXJSLjrKGNCenSYvR"};